import React from "react";

interface DefaultButtonProps {
  id?: string;
  text: any;
  onClick?: () => void;
  bgColor?: string;
  textColor?: string;
  className?: string;
  icon?: React.ReactNode;
  disabled?: boolean;
  title?: string;
  style?: React.CSSProperties;
  iconPosition?: "left" | "right";
  type?: "button" | "submit" | "reset";
}

export default function DefaultButton({
  id,
  text,
  onClick,
  bgColor = "PrimaryColor",
  textColor = "white",
  className = "",
  icon,
  disabled = false,
  title,
  style,
  iconPosition = "left",
  type = "button",
}: DefaultButtonProps) {
  return (
    <button
      id={id}
      type={type}
      // `bgColor` / `textColor` are partner values resolved at paint time, so
      // the fill stays inline and no utility can express it. The hover is a
      // 5% darkening of whatever that fill turns out to be, rather than the
      // old blanket `opacity-80`, which faded the label along with the
      // background and made the button look disabled while pointed at.
      className={`flex select-none items-center justify-center gap-2 rounded-control px-4 py-1 w-full transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--demo-secondary)] focus-visible:ring-offset-2 ${
        iconPosition === "right" ? "flex-row-reverse" : ""
      } ${
        disabled
          ? "cursor-not-allowed bg-line text-mist"
          : "cursor-pointer hover:brightness-95 active:brightness-90"
      } ${className}`}
      onClick={disabled ? undefined : onClick}
      style={{
        background: disabled ? undefined : bgColor,
        color: disabled ? undefined : textColor,
        ...style,
      }}
      title={title}
    >
      {icon && <span className={`flex items-center`}>{icon}</span>}
      {text}
    </button>
  );
}
